export const FOCUS_EDITOR = 'editor.focus'
